import { render, staticRenderFns } from "./HUserBalance.vue?vue&type=template&id=082a85fc&scoped=true&"
import script from "./HUserBalance.vue?vue&type=script&lang=js&"
export * from "./HUserBalance.vue?vue&type=script&lang=js&"
import style0 from "./HUserBalance.vue?vue&type=style&index=0&id=082a85fc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082a85fc",
  null
  
)

export default component.exports